export default __webpack_public_path__ + "static/media/404.3a940680.svg";